import Sponsors from "./index";
import {Layout} from "@components/common";
import {fetchJson, getShopNavigation} from "../index";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";

export async function getServerSideProps(context: any) {
  const {locale, params} = context;
  const url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}`;
  const sponsorGallery = await fetchJson(url + '/api/sponsor-gallery?populate[0]=Sponsors.Url&populate[1]=Sponsors.Name&populate[2]=Sponsors.Logo', 'data.attributes.Sponsors');
  let mainSponsors: any[] = [];
  let titleSponsors: any[] = [];
  let partners: any[] = [];
  let suppliers: any[] = [];
  if (sponsorGallery && sponsorGallery.length > 0) {
    sponsorGallery.forEach((sponsor: any) => {
      if (!sponsor.isU19) {
        return;
      }
      if (sponsor.isMainSponsor) {
        mainSponsors.push(sponsor);
      }
      if (sponsor.isTitleSponsor) {
        titleSponsors.push(sponsor);
      }
      if (sponsor.isPartner) {
        partners.push(sponsor);
      }
      if (sponsor.isSupplier) {
        suppliers.push(sponsor);
      }
    });
  }
  return {
    props: {
      mainSponsors,
      titleSponsors,
      partners,
      suppliers,
      ...(await serverSideTranslations(locale, ["common", "home"])),
      ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
    }
  }
}

export default Sponsors
Sponsors.Layout = Layout
